import { render, staticRenderFns } from "./UsersOverview.vue?vue&type=template&id=d3392460"
import script from "./UsersOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports